import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  roleLoading: false,
  roleSuccess: null,
  roleError: '',
  rolesListLoading: false,
  rolesListSuccess: null,
  rolesListError: '',
  editRoleLoading: false,
  editRoleSuccess: null,
  editRoleError: '',
  adminRolesLoading: false,
  adminRolesSuccess: [],
  adminRolesError: ""
}

export const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    setRoleLoading: (state, action) => {
      state.roleLoading = true;
      state.roleSuccess = null;
      state.roleError = '';
    },
    setRoleSuccess: (state, action) => {
      state.roleLoading = false;
      state.roleSuccess = action.payload;
      state.roleError = '';
    },
    setRoleError: (state, action) => {
      state.roleLoading = false;
      state.roleSuccess = null;
      state.roleError = action.payload;
    },
    setRolesListLoading: (state, action) => {
      state.rolesListLoading = true;
      state.rolesListSuccess = null;
      state.rolesListError = '';
    },
    setRolesListSuccess: (state, action) => {
      state.rolesListLoading = false;
      state.rolesListSuccess = action.payload;
      state.rolesListError = '';
    },
    setRolesListError: (state, action) => {
      state.rolesListLoading = false;
      state.rolesListSuccess = null;
      state.rolesListError = action.payload;
    },
    setEditRoleLoading: (state) => {
      state.editRoleLoading = true;
      state.editRoleSuccess = null;
      state.editRoleError = '';
    },
    setEditRoleSuccess: (state, action) => {
      state.editRoleLoading = false;
      state.editRoleSuccess = action.payload;
      state.editRoleError = '';
    },
    setEditRoleError: (state, action) => {
      state.editRoleLoading = false;
      state.editRoleSuccess = null;
      state.editRoleError = action.payload;
    },

    setAdminRolesLoading: (state, action) => {
      state.adminRolesLoading = true
      state.adminRolesSuccess = []

    },
    setAdminRolesSuccess: (state, action) => {
      state.adminRolesLoading = false
      state.adminRolesSuccess = action.payload.data.map((item) => ({ ...item, label: item.name, value: item.roleId }))

    },
    setAdminRolesError: (state, action) => {
      state.adminRolesLoading = false
      state.adminRolesSuccess = []
      state.adminRolesError = action.payload.message

    }
  },
})

// Action creators are generated for each case reducer function
export const { setRoleLoading, setRoleSuccess, setRoleError, setRolesListLoading, setRolesListSuccess,
  setRolesListError,
  setEditRoleLoading,
  setEditRoleSuccess,
  setEditRoleError,
  setAdminRolesLoading,
  setAdminRolesSuccess,
  setAdminRolesError
} = roleSlice.actions

export default roleSlice.reducer;